import { requestWithToken } from '../utilities/request';
import SessionStorageService from './utilities/SessionStorageService';
import AuthProvider, { needTokenUpdate } from '../utilities/authProvider';
import { API } from '../utilities/constants';
const path = '/api/private/fields';

const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/machineries/list`),
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const listForMachineryUses = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/machineries/list_for_machinery_uses`),
    params: param,
  });
};

const create = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/machineries`),
    params: param,
  });
};

const show = (fieldId, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/machineries/${id}`),
  });
};

const update = (fieldId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/machineries/${id}`),
    data: param,
  });
};

const updateOrder = (field_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${field_id}/machineries/update_order`),
    data: param,
  });
};

const del = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/machineries/${id}`),
  });
};

const getUrlExportExcel = async fieldId => {
  let token = SessionStorageService.getToken();
  if (needTokenUpdate(token)) {
    token = await AuthProvider.instance.silentTokenUdate();
  }
  return `${
    API.endpoint
  }/api/private/fields/${fieldId}/machineries/bulk_export.xlsx?excel_token=${token}`;
};

const getExportExcelFileInfo = async (url, params) => {
  return requestWithToken({
    method: 'GET',
    url,
    params,
  });
};

const bulkExportExcel = url => {
  return requestWithToken({
    method: 'GET',
    url,
    responseType: 'blob',
  });
};

const bulkImportExcel = (fieldId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/machineries/bulk_import`),
    data,
  });
};

const bulkDelete = (fieldId, data) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/machineries`),
    data,
  });
};

export const MachineryService = {
  list,
  listForMachineryUses,
  create,
  show,
  update,
  updateOrder,
  del,
  getUrlExportExcel,
  getExportExcelFileInfo,
  bulkExportExcel,
  bulkImportExcel,
  bulkDelete,
};

export default MachineryService;



// WEBPACK FOOTER //
// ./src/services/Machineries.js